export default "/images/vendor/flag-icons/flags/1x1/af.svg?fafb36ef623dc93fe5ed6946a803a1b0";